// extracted by mini-css-extract-plugin
module.exports = {"component":"CollateralRatio_component__1YO7v","compact":"CollateralRatio_compact__1B-ey","percent":"CollateralRatio_percent__PdPob","load":"CollateralRatio_load__2Wt9b"};